import React from "react";
import { Link } from "react-router-dom";
import img from "../../commons/img/ubaform-logo.svg";

export function Header({ mode }) {
  let LinkUi;

  if (mode === "forgot-password") {
    LinkUi = (
      <Link to="/auth" className="btn btn_primary uppercase ml-5">
        Login
      </Link>
    );
  }
  return (
    <section className="top-bar">
      <div className="brand">
        <img alt="nadi" src={img} style={{ width: 170 }} />
      </div>
      <nav className="flex items-center ml-auto">{LinkUi}</nav>
    </section>
  );
}
